import { FC, useContext, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link } from "react-router-dom";

import FooterText from "../../components/footerText";
import HubInputField from "../../components/inputType";

import useFetch from "../../hooks/useFetch";
import { ToastContext } from "../../context/toastContext";
import { forgotpasswordSchema } from "../../validation/forgotPassword";
import { APIEndpoints } from "../../types/apiTypes";
import { ToastTypes } from "../../types";
import { ForgotPasswordResponseType } from "./types";
import { LoaderContext } from "../../context/loaderContext";
// import ContactAndSafetyInfo from "../../components/contactAndSafetyInfo";
// import {TextAlignProps} from "../../components/contactAndSafetyInfo/types";






const HubForgotPassword: FC = (): JSX.Element => {
  const { control, handleSubmit, reset } = useForm({
    mode: 'all',
    resolver: yupResolver(forgotpasswordSchema),
  });
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);





  const { loading, error, data, mutate, removeErrorAndData } = useFetch<null, null, ForgotPasswordResponseType>(APIEndpoints.USER_FORGOT_PASSWORD);

  useEffect(() => {
    if (data || error) {
      hideLoader();
      if (data) {
        const { message } = data;
        showToast([message], ToastTypes.SUCCESS);
        reset();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error]);

  const submitForm = async (values: { email: string }) => {
    setLoader();
    if ((error && error.length > 0) || data) removeErrorAndData();

    mutate({ user: values });
  };




  return (
      <div className="container-fluid login-sec pt-4 p-0 overflow-auto d-flex flex-column flex-fill">
        <div className="container flex-fill">
          <form className="card" onSubmit={handleSubmit(submitForm)}>
            <div className="card-header">
              <h1 className="m-0">Forgot your password?</h1>
            </div>
            <div className="card-body">
              <Controller
                  name="email"
                  control={control}
                  defaultValue=""
                  render={({field, fieldState: {error}}) => (
                      <HubInputField
                          inputId="email"
                          isRowBased={false}
                          isRequired={true}
                          field={field}
                          error={error}
                          inputLabel="Email"
                          inputType="email"
                      />
                  )}
              />

              <div className="">
                <button disabled={loading} className="btn btn-primary rounded-0" type="submit">
                  {loading ? (<i className="spinner-border me-2"></i>) : null}
                  Send me reset password instructions
                </button>
                <p className="mb-0 mt-2">
                  <Link to="/users/sign_in">Log in</Link>
                </p>
              </div>
              {/*<hr/>*/}
              {/*<ContactAndSafetyInfo alignText={TextAlignProps.TEXT_CENTER} textColor="black"/>*/}
            </div>
          </form>
        </div>
        <FooterText footerType="black"/>
      </div>
  );
};
export default HubForgotPassword;
